let imageChangeTimeout; // Variable to store timeout ID

window.onload = function () {
  const URL = window.location.href;
  document.getElementById("copy-button").innerHTML =
    '<a class="btn btn-outline-secondary btn-lg btnClipboardJS" data-clipboard-text="' +
    URL +
    '" id="alertCard"><img src="https://cdn.shopify.com/s/files/1/0532/6041/9223/files/link-share-icon-24w.png?v=1707317930" alt="Clipboard Icon" width="24" height="24"></a>';

  new ClipboardJS(".btnClipboardJS").on("success", function () {
    copiedToClipboard();
  });
};

function copiedToClipboard() {
  // Change the image source directly
  const img = document.querySelector("#alertCard img");
  img.src =
    "https://cdn.shopify.com/s/files/1/0532/6041/9223/files/icons8-check-30.png?v=1707318366";

  // Clear any existing timeout
  clearTimeout(imageChangeTimeout);

  // Set timeout to reset image source after 3 seconds
  imageChangeTimeout = setTimeout(function () {
    img.src =
      "https://cdn.shopify.com/s/files/1/0532/6041/9223/files/link-share-icon-24w.png?v=1707317930";
  }, 3000);
}

function addToCart(selectedSellingPlanID, selectedVariantID) {
  const form = document.querySelector(".shopify-product-form");
  let formData = new FormData(form);
  formData.append("id", selectedVariantID);
  formData.append("quantity", 1);
  formData.append("selling_plan", selectedSellingPlanID);

  const results = Object.fromEntries(formData);
  const payLoad = JSON.stringify(results);

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: payLoad,
  })
    .then((res) => res.json())
    .then(() => {
      console.log(this);
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((err) => console.log(err))
    .finally(() => {
      document.dispatchEvent(new CustomEvent("variant:add"));
      // This event should be triggering the cart icon count in the header but is consistently failing
      // document.dispatchEvent(new CustomEvent("cart:change"))
    });
}

$(document).ready(function () {
  const subscribeAndSaveRadio = document.querySelector(
    'input[value="subscribeAndSave"]'
  );
  const oneTimePurchaseRadio = document.querySelector(
    'input[value="oneTimePurchase"]'
  );

  setTimeout(function () {
    $("#video-banner").contents().unwrap();
  }, 50);

  $(".button--recharge-atc").click(function () {
    if (subscribeAndSaveRadio.checked) {
      event.preventDefault();

      let selectedSubSaveOption = document.querySelector(
        ".toggle-buttons .toggle-button.selected"
      );
      let subSavePlan = parseInt(
        selectedSubSaveOption.getAttribute("data-selling-plan")
      );
      let subSaveProduct = parseInt(
        selectedSubSaveOption.getAttribute("data-product-id")
      );

      console.log("subsave purchase");
      addToCart(subSavePlan, subSaveProduct);
    } else if (oneTimePurchaseRadio.checked) {
      console.log("one time purchase");
    }
  });

  // Custom Recharge Widget by Aessymetric //
  var price = $(".recharge-container-main.active .recharge-price-main").text();
  if(!price){
    const buyButtons = document.querySelectorAll('.buy-buttons[data-price]');
    buyButtons.forEach(function (buyButton) {
      let dataPrice = buyButton.getAttribute('data-price');
      if(buyButton.querySelector('.selected-price')){
        price = dataPrice;
      }
    })
  }
  
  var formattedPrice = "--- " + price;
  $(".selected-price").text(formattedPrice);

  oneTimePurchaseRadio.addEventListener("change", function () {
    console.log("Clicked One-Time Purchase radio button");
    if (this.checked) {
      $(".toggle-buttons .toggle-button").eq(0).click();

      document.querySelector(".toggle-container").style.display = "none";
      document
        .querySelector(".recharge--subscribeAndSave")
        .classList.remove("active");
      document
        .querySelector(".recharge--oneTimePurchase")
        .classList.add("active");

      var price = $(
        ".recharge-container-main.active .recharge-price-main"
      ).text();
      var formattedPrice = "--- " + price;
      $(".selected-price").text(formattedPrice);

      // Click the corresponding element
      var element = document.querySelector(
        '.rc_widget__option__input--onetime[value="onetime"]'
      );
      if (element) {
        element.click();
      }
    }
    var otpTrifecta = document.querySelector(".otp-trifecta");
    if (otpTrifecta) {
      otpTrifecta.classList.add("hidden-otp-trifecta");
      console.log(".otp-trifecta element hidden (class added)");
    } else {
      console.log(".otp-trifecta element not found");
    }

    var rcTrifecta = document.querySelector(".rc-trifecta");
    if (rcTrifecta) {
      rcTrifecta.innerHTML = "$330.00";
      console.log(".rc-trifecta element hidden (class added)");
    } else {
      console.log(".rc-trifecta element not found");
    }
  });

  subscribeAndSaveRadio.addEventListener("change", function () {
    console.log("Clicked Subscribe & Save radio button");
    if (this.checked) {
      // Display the toggle container
      document.querySelector(".toggle-container").style.display = "flex";

      document
        .querySelector(".recharge--subscribeAndSave")
        .classList.add("active");
      document
        .querySelector(".recharge--oneTimePurchase")
        .classList.remove("active");

      var price = $(
        ".recharge-container-main.active .recharge-price-main"
      ).text();
      var formattedPrice = "--- " + price;
      $(".selected-price").text(formattedPrice);

      // Remove the class to show .otp-trifecta
      var otpTrifecta = document.querySelector(".otp-trifecta");
      if (otpTrifecta) {
        otpTrifecta.classList.remove("hidden-otp-trifecta");
        console.log(".otp-trifecta element displayed (class removed)");
      } else {
        console.log(".otp-trifecta element not found");
      }

      var rcTrifecta = document.querySelector(".rc-trifecta");
      if (rcTrifecta) {
        rcTrifecta.innerHTML = "$264.00";
        console.log(".rc-trifecta element hidden (class added)");
      } else {
        console.log(".rc-trifecta element not found");
      }

      // Click the corresponding element
      var element = document.querySelector(
        '.rc_widget__option__input--subsave[value="subsave"]'
      );
      if (element) {
        element.click();
      }

      function checkOptionCount() {
        var selectElement = document.querySelector(
          ".rc_widget__option__plans__dropdown"
        ); // corrected class selector
        if (selectElement) {
          var optionCount = selectElement.options.length;

          if (optionCount <= 2) {
            setTimeout(() => {
              if (optionCount === 1) {
                document.getElementById("toggle45").style.display = "none";
                document
                  .querySelectorAll(".toggle-buttons")
                  .forEach((element) => {
                    element.classList.add("justify-center-content");
                  });
              } else {
                document.getElementById("toggle45").style.display = "block";
              }
            }, 100);
          }
        }
      }

      setTimeout(() => {
        checkOptionCount();
      }, 100);
    }
  });


  $(".toggle-buttons .toggle-button").on("click", function () {
    var value = $(this).attr("data-value");
    $(".toggle-buttons .toggle-button").removeClass("selected");
    $(this).addClass("selected");

    if (document.querySelector("[data-plan-option]")) {
      document.querySelector('[data-plan-option="' + value + '"]').click();
      var toggleDays = $('[data-plan-option="' + value + '"]').val();
      document.querySelector(".rc_widget__option__plans__dropdown").value =
        toggleDays;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  if (body && body.id === "premium-skincare-by-dr-amir-karam-karammd-skin") {
    if (window.innerWidth <= 1024) {
      const videoDiv = document.getElementById("video-full-width");
      const section = document.querySelector(".section");

      if (videoDiv && section) {
        section.parentNode.insertBefore(videoDiv, section);
      }
    }
  }
});
;

document.addEventListener('DOMContentLoaded', function () {
  let videoSlide = document.querySelector('.product__media-item--video');
  let slider = document.querySelector('.product__media-slider');

  if (videoSlide && slider) {
    videoSlide.addEventListener('click', function () {
      // Ensure the slider can still be navigated
      setTimeout(() => {
        slider.classList.remove('swiper-disabled');
      }, 500);
    });
  }
});
